export default __webpack_public_path__ + "static/media/rank_predictor.d598c8ed.png";